import React, { createContext, useContext } from 'react'
import { type Theme, themes, type ThemeType } from './themes'

interface ThemeContextType {
  theme: Theme
  setTheme: (theme: ThemeType) => void
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [currentTheme, setCurrentTheme] = React.useState<ThemeType>('default')

  const value = React.useMemo(() => ({
    theme: themes[currentTheme],
    setTheme: setCurrentTheme
  }), [currentTheme])

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) {
    return {
      theme: themes.default,
      setTheme: () => {}
    }
  }
  return context
}